<template>
  <b-card header-tag="header" class="apply-box">
    <h4>The submission of this form will trigger a job that will attempt to perform the following updates:</h4>
    <ol>
      <li>It attempts to import the application of this ID from your eArcu instance if we don’t already have it, ignoring the channel ID set as the application’s source.</li>
      <li>Updates the application status from eArcu where we already have an application in Real Links.</li>
      <li>Rewards the referrer where eArcu recorded a tracking ID.</li>
    </ol>
    <p>Please note that this means it will import an application even if eArcu have not identified it as being sourced from Real Links.</p>
    <p>If eArcu did not record the source as Real Links, the application will not receive any further updates automatically. You can update it again manually by using this form.</p>
    <p>The job will run asynchronously and may take a few minutes to complete.</p>
    <hr />
    <advanced-form
      autocomplete="off"
      submit-label="Import Application"
      :form="formFields"
      v-bind="form"
      v-model="form"
      @submit="input()"
    />
    <b-row>
      <b-col cols="12" v-if="triggered">
        <h3 class="text-center pt-3">Import started. Please wait…</h3>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import AdvancedForm from '@/components/AdvancedForm';
import { mapRoot } from '@src/mixins/root';
import gql from 'graphql-tag';

const ImportJobApplicationsMutation = gql`
  mutation ImportJobApplication($input: String!) {
    importJobApplication(input: $input)
  }
`;

export default {
  name: 'Apply-Import-Recruiter',
  components: {
    AdvancedForm
  },
  data: () => ({
    triggered: false,
    form: {},
    err: null,
    state: null,
  }),
  props: {
    applicationsArray: Array,
  },
  computed: {
    ...mapRoot([ 'isRecruiter' ]),
    formFields() {
      return {
        applicationID: {
          label: 'Application (or “Anonymised”) ID',
          placeholder: 'e.g. 1234',
          required: true,
          type: 'NUMBER',
          options: {
            autocomplete: 'off',
          },
        }
      };
    },
  },
  methods: {
    async input() {
      this.triggered = true;

      const input = {
        applicationID: this.form.applicationID,
        integrationType: 'earcu',
      };
      try {
        const response = await this.$apollo.mutate({
          mutation: ImportJobApplicationsMutation,
          variables: { input: JSON.stringify(input) },
        });

        const { data: { importJobApplication } } = response;
        const { status, message } = importJobApplication ? JSON.parse(importJobApplication) : {};

        if (status === 'success') {
          this.$notification({ title: 'Import Routine Completed', message, variant: 'success' });
        } else {
          this.$notification({ title: 'An Error Occurred', message, variant: 'danger' });
        }
      } catch (error) {
        console.log(error);
        this.$notification({ title: 'An Error Occurred', message: error.message, variant: 'danger' });
      }
    },
  }
};
</script>

<style lang="scss">
  @import './../../scss/variables';

  .apply-box {
    form {
      padding: 1rem;
      width: 100%;
    }

    .btn {
      margin: 0 auto;
    }

    .btn-primary {
      margin-top: 1em;
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/jobs/applyEArcuImport.vue